import './NewYearLoader.scss';

function NewYearLoader() {
  return (
    <svg width="220" height="150" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%">
          <stop offset="0%" stop-color="#1a3b7c" />
          <stop offset="50%" stop-color="#6b8df2" />
          <stop offset="100%" stop-color="#1a3b7c" />
        </linearGradient>
      </defs>

      {/* <!-- Calendar Body --> */}
      <g class="calendar">
        <rect x="50" y="50" rx="20" width="200" height="200" fill="#1a3b7c" />

        {/* <!-- Rings --> */}
        <g transform="translate(50 35)">
          <rect class="ring" x="30" width="10" height="28" rx="5" />
          <rect class="ring" x="70" width="10" height="28" rx="5" />
          <rect class="ring" x="120" width="10" height="28" rx="5" />
          <rect class="ring" x="160" width="10" height="28" rx="5" />
        </g>

        {/* <!-- Back Page --> */}
        <g opacity="0.85">
          <rect x="65" y="80" width="170" height="160" rx="12" class="page" />
          <text x="150" y="160" class="year">
            2026
          </text>
        </g>

        {/* <!-- Front Page --> */}
        <g>
          <rect x="65" y="80" width="170" height="160" rx="12" class="page" />
          <polygon
            class="tear"
            points="65,80 70,92 75,80 80,92 85,80 90,92 95,80
                100,92 105,80 110,92 115,80 120,92 125,80
                130,92 135,80 140,92 145,80 150,92 155,80
                160,92 165,80 170,92 175,80 180,92 185,80
                190,92 195,80 200,92 205,80 210,92 215,80
                220,92 225,80"
          />
          <text x="150" y="160" class="year">
            2025
          </text>

          {/* <!-- Tear Animation --> */}
          <animateTransform
            type="translate"
            attributeName="transform"
            dur="2.8s"
            repeatCount="indefinite"
            keyTimes="0;0.3;0.6;1"
            values="0 0; -2 8; 18 260; 18 260"
          />

          <animateTransform
            additive="sum"
            type="rotate"
            attributeName="transform"
            dur="2.8s"
            repeatCount="indefinite"
            keyTimes="0;0.3;0.6;1"
            values="0 65 80; -6 65 85; 14 65 260; 14 65 260"
          />

          <animate
            attributeName="opacity"
            dur="2.8s"
            repeatCount="indefinite"
            keyTimes="0;0.55;1"
            values="1;0;0"
          />
        </g>
      </g>
    </svg>
  );
}

export default NewYearLoader;
